module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      "transform": "translateY(" + _vm.distance + "px)"
    }),
    attrs: {
      "id": "index-scroll-content"
    }
  }, [_c('refresh', {
    attrs: {
      "length": _vm.distance
    }
  }), _vm._v(" "), _c('swiperIndex'), _vm._v(" "), _c('activity'), _vm._v(" "), _c('indexEntry'), _vm._v(" "), _c('headLine'), _vm._v(" "), _c('taoqianggou')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-012c8ae6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/scrollContent.vue
// module id = 42
// module chunks = 1